import { atom } from 'jotai'
import { PointRef } from 'slate'

type GenerationState = {
  generationPointRef: PointRef
}

export const generationAtom = atom<GenerationState | undefined>(undefined)
